import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Tag } from 'src/app/models/tag.model';
import { TagsService } from 'src/app/services/tags.service';
import { VideosService } from 'src/app/services/videos.service';

@Component({
  selector: 'tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent implements AfterViewInit {

  constructor(private tagsService: TagsService, private videosService: VideosService, private router: Router) { }
  
  @Output()
  scrollAlmostEnd:EventEmitter<any>=new EventEmitter<any>()

  ngAfterViewInit(): void {
    this.scroll2 = this.scroll.nativeElement;
  }

  @Input()
  tags: Tag[] = []

  @Input()
  finishedLoading:boolean
  
  @Input()
  loading:boolean

  @ViewChild('scroll') scroll: ElementRef;

  scrollInterval:any

  scroll2: HTMLElement = document.createElement('li')//אין משמעות לאלמנט, לצורך טיתחול בלבד

  scrollSide(side: string) {
    this.sideScroll(this.scroll.nativeElement, side, 10, 250, 5);
  };

  stopScroll(){
    window.clearInterval(this.scrollInterval);
  }

  onScroll(){
    if(this.scroll2.scrollLeft-1 <= 0 - this.scroll2.scrollWidth + this.scroll2.offsetWidth+500 )
        this.scrollAlmostEnd.emit('')//אם הגיעו למרחק של 220 פיקסלים מהסוף, שולחים אירוע (כדי לטעון עוד תגיות)
      
  }

  sideScroll(element: HTMLElement, direction: string, speed: number, distance: number, step: number) {
    var scrollAmount = 0;
    window.clearInterval(this.scrollInterval);
    this.scrollInterval = setInterval( () => {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } 
      else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if(scrollAmount>=distance||scrollAmount>=distance||element.scrollLeft >= 0||element.scrollLeft-1 <= 0 - element.scrollWidth + element.offsetWidth)
      this.stopScroll()
 
    }, speed);
  }
}


